import { commits, getters } from '/@/modules/core/app/helpers/store';
import { BaseService } from '/@/modules/core/app/services/abstracts/BaseService';
import { ConversationCollection } from '@/modules/messenger/_modules/conversation/models/ConversationCollection';
import InboxResource from '/@/modules/inbox/resources/InboxResource';

export class InboxConversationService extends BaseService {
  /**
   * @var {InboxResource}
   */
  resource;

  constructor() {
    super();

    this.resource = InboxResource;
  }

  /**
   * @returns {Promise<Conversation>}
   */
  createDefaultConversation() {
    const currentUser = getters.auth.getUser();

    if (!currentUser.currentEstate) {
      return undefined;
    }

    return this.resource.createDefaultConversation();
  }

  /**
   * @param {string} conversationId
   * @returns {Promise<Conversation>}
   */
  getConversation(conversationId) {
    return this.resource.getConversation(conversationId);
  }

  /**
   * @returns {Promise<ConversationCollection>}
   */
  async getConversations(userId) {
    const conversations = await this.resource.getConversations(userId);

    return ConversationCollection.mapModel(conversations);
  }

  /**
   * @returns {Promise<Conversation[]>}
   */
  async getUnreadConversations() {
    const conversations = await this.resource.getUnreadConversations();
    commits.inbox.setUnreadConversations(conversations);

    return conversations;
  }
}

export default new InboxConversationService();
